module.exports = __webpack_public_path__ + "img/cyber-defence-24.3e682d6f.svg";